import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿En qué formato recibiré la guía?',
  answer: 'La recibirás en formato digital descargable con acceso inmediato.'
}, {
  question: '¿Necesito conocimientos previos en nutrición?',
  answer: 'No. Todo está explicado paso a paso de forma clara y sencilla.'
}, {
  question: '¿Cuánto tiempo tengo acceso?',
  answer: 'El acceso es ilimitado para que avances a tu ritmo.'
}, {
  question: '¿Cuándo empezaré a notar cambios?',
  answer: 'Muchas mujeres comienzan a sentir mejoras en energía y descanso en las primeras semanas, siempre que apliquen el método de forma constante.'
}, {
  question: '¿Esto reemplaza tratamiento médico?',
  answer: 'No. Es una guía educativa de acompañamiento y bienestar integral.'
}];
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}) {
  return <div className="border-b border-[#7C9A6E]/20 last:border-b-0" data-id="element-39">
      <button onClick={onClick} className="w-full py-5 flex items-center justify-between text-left hover:text-[#7C9A6E] transition-colors" data-id="element-40">
        <span className="text-lg font-semibold text-[#2D2926] pr-4" data-id="element-41">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-42">
          <ChevronDownIcon className="w-5 h-5 text-[#7C9A6E] flex-shrink-0" data-id="element-43" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-44">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="overflow-hidden" data-id="element-45">
            <p className="pb-5 text-[#2D2926]/70 leading-relaxed" data-id="element-46">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQ() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 px-4 bg-white" ref={ref} data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-3xl md:text-4xl font-bold text-center text-[#2D2926] mb-12" data-id="element-49">
          PREGUNTAS FRECUENTES
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="bg-[#FAF7F2] rounded-2xl p-6 md:p-8" data-id="element-50">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-51" />)}
        </motion.div>
      </div>
    </section>;
}